import { cn } from "@/src/shared/utils/mergeTwClasses";
import { AppBar, Container, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { isEmpty, isNil } from "lodash";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";
import type { HeaderProps } from "../lib/type";
import { HeaderActionsMenu } from "./HeaderActionsMenu";
import { HeaderAlertClientWrapper } from "./HeaderAlertClientWrapper";
import { Logo } from "@/public/icons/logo";
import { isNotificationHidden } from "../lib/utils";

export const Header: FC<HeaderProps> = ({
  logo,
  workSchedules,
  style,
  actions,
  contacts,
  notification,
  displaySchedule,
  analytics,
}) => {
  const isAlertShown = !isNotificationHidden(displaySchedule);
  return (
    <AppBar
      className={cn(
        "drop-shadow-header sticky top-0 z-header flex flex-col bg-white shadow-header",
        { "h-14": isEmpty(actions) },
        style?.background,
        // style?.boxShadow,
        style?.padding,
      )}
    >
      <Container
        component={"nav"}
        className={cn(
          "w-full justify-between py-3 flex-center-row max-md:px-3",
        )}
      >
        <Stack className={"gap-6 flex-center-row"}>
          {!isEmpty(logo) && !isNil(logo.src) ? (
            <Link href={"/"} className={"flex"} aria-label={"Go to homepage"}>
              <Image
                src={logo.src}
                width={logo?.width ?? 40}
                height={logo?.height ?? 40}
                alt={logo.alt ?? "logo"}
                priority
                quality={100}
              />
            </Link>
          ) : (
            <Logo />
          )}
          {workSchedules?.map((schedule, index) => (
            <Stack
              key={index}
              className={cn("gap-1", {
                hidden: index !== 0,
                "md:flex": index !== 0,
              })}
            >
              <Typography variant={"body2"}>{schedule.title}</Typography>
              <Typography
                variant={"body2"}
                className={"text-[15px] font-semibold leading-4 text-blue"}
              >
                {schedule.subTitle}
              </Typography>
            </Stack>
          ))}
        </Stack>
        {!isNil(actions) && !isNil(contacts) ? (
          <HeaderActionsMenu actions={actions} contacts={contacts} />
        ) : null}
      </Container>
      {isAlertShown && !isEmpty(notification) && !notification.hidden ? (
        <HeaderAlertClientWrapper title={notification.text ?? ""} />
      ) : null}
    </AppBar>
  );
};
